import React, { useEffect } from 'react';
import { Box, Text } from '@rebass/emotion';
import BgImage from '@images/rls-thankyou.jpeg';
import Colors from '@theme/colors';
import { css } from '@emotion/core';

interface CompletePageProps {
  mq: (param: any) => any;
  description?: string;
  description2?: string;
  description3: string;
  textList: string[];
  description4: string;
  description5: string;
  heading?: string;
  isEligible?: boolean;
  alreadyApplied: boolean;
  respondentServerError?: boolean;
}

const CompletePage = ({
  mq,
  description,
  description2,
  description3,
  textList,
  description4,
  description5,
  isEligible,
  alreadyApplied,
  heading,
  respondentServerError,
}: CompletePageProps) => {
  const renderEligibleText = () => {
    return (
      <>
        <h2
          css={mq({
            fontSize: ['1.2rem', '2.2rem', '2.4rem', '2.72rem'],
            color: '#6cc24a',
            fontWeight: '700 !important',
            marginBottom: '1.4rem',
            lineHeight: 1.2,
            marginTop: '0px',
            textTransform: 'UPPERCASE',
          })}
        >
          {heading}
        </h2>
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
            marginTop: '0px',
            marginBottom: '16px',
          })}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
            marginTop: '0px',
            marginBottom: '16px',
          })}
          dangerouslySetInnerHTML={{
            __html: description2,
          }}
        />
        <ul
          css={mq({
            paddingLeft: '0px',
            marginTop: '0px',
            marginBottom: '10px',
            marginLeft: '20px',
            color: '#3d3f4f',
            lineHeight: 1.6,
          })}
        >
          {textList.map((text, index) => (
            <li
              key={index}
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            />
          ))}
        </ul>
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            marginTop: '0px',
            marginBottom: '16px',
            lineHeight: 1.6,
          })}
          dangerouslySetInnerHTML={{
            __html: description3,
          }}
        />
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
            marginTop: '0px',
            marginBottom: '16px',
          })}
          dangerouslySetInnerHTML={{
            __html: description4,
          }}
        />
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
            marginTop: '0px',
            marginBottom: '16px',
          })}
          dangerouslySetInnerHTML={{
            __html: description5,
          }}
        />
      </>
    );
  };

  const renderInEligibleText = () => {
    return (
      <>
        <h2
          css={mq({
            fontSize: ['1.2rem', '2.2rem', '2.4rem', '2.6rem'],
            color: '#6cc24a',
            fontWeight: '700 !important',
            marginBottom: '1.4rem',
            lineHeight: 1.2,
            marginTop: '0px',
            textTransform: 'UPPERCASE',
          })}
        >
          {heading}
        </h2>
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
          })}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </>
    );
  };

  const renderAlreadyApplied = () => {
    return (
      <>
        <h2
          css={mq({
            fontSize: ['1.2rem', '2.2rem', '2.4rem', '2.6rem'],
            color: '#6cc24a',
            fontWeight: '700 !important',
            marginBottom: '1.4rem',
            lineHeight: 1.2,
            marginTop: '0px',
            textTransform: 'UPPERCASE',
          })}
        >
          {heading}
        </h2>
        <p
          css={mq({
            fontSize: ['16px', '18px', '20px', '22px'],
            fontWeight: '700 !important',
            lineHeight: 1.6,
          })}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </>
    );
  };

  return (
    <Box
      css={mq({
        minHeight: 'calc(100vh - 177px)',
        background: `url(${BgImage}) no-repeat top center`,
        backgroundSize: 'cover',
        marginBottom: 0,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'center',
      })}
    >
      {respondentServerError ? (
        <Text
          css={css`
            position: absolute;
            top: 0px;
            width: 50%;
            border: 1px solid ${Colors.redLight1};
            border-radius: 3px;
            background-color: ${Colors.redLight4};
            color: ${Colors.errorMsg1};
            letter-spacing: 0;
            line-height: 20px;
            margin: 0 auto 30px;
            padding: 15px 5px;
            text-align: center;
          `}
        >
          Sorry, our servers are currently down. Please come back later.
        </Text>
      ) : (
        <Box
          maxWidth={['100%', '80%', '80%', '1170px']}
          width="100%"
          pr="15px"
          pl="15px"
          mr="auto"
          ml="auto"
          display="flex"
          id="complete-page-chat"
        >
          <Box
            css={mq({
              width: ['100%', '100%', '60%', '40%'],
            })}
          >
            <Box
              css={mq({
                maxWidth: ['100%', '100%', '500px', '500px'],
                width: ['100%'],
                textAlign: 'left',
                margin: '32px auto',
                background: 'rgba(255,255,255,.85)',
                padding: '32px',
                position: 'relative',
              })}
            >
              {alreadyApplied ? renderAlreadyApplied() : isEligible ? renderEligibleText() : renderInEligibleText()}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export { CompletePage };
